import React from "react";
import {
  Card,
  CardContent,
  Box,
} from "@mui/material";
import { Person as PersonIcon } from "@mui/icons-material";
import CustomSelect from "../FormFields/CustomSelect/CustomSelect";
import CustomInput from "../FormFields/CustomInput/CustomInput";
import CustomDate from "../CustomForm/CustomDate";
import ImageUpload from "../CustomForm/ImageUpload";
import CardHeaderComponent from "./CardHeaderComponent";
import { genderOptions } from "./CandidateForm.Config";

const CandidateProfileForm = ({
  handleFileUpload,
  handleChange,
  data,
}) => {
  const genderOptionsFormatted = genderOptions.map((item) => ({
    value: item.value || item,
    label: item.name || item,
  }));

  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 2,
        borderColor: '#e2e8f0',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        overflow: 'hidden',
      }}
    >
      <CardHeaderComponent icon={PersonIcon} title="Profile" />
      <CardContent sx={{ p: 2.5 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box>
            <ImageUpload
              name="profile_photo"
              label="Profile Photo"
              onChange={handleFileUpload}
              value={data?.profile_photo_url || data?.profile_photo}
              accept="image/jpeg,image/png"
              maxSize={5 * 1024 * 1024}
              folder="profile_photos"
              circular={true}
              preview={true}
              required={false}
            />
          </Box>
          
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            <Box sx={{ flex: '1 1 calc(50% - 8px)', minWidth: '150px' }}>
              <CustomInput
                name="first_name"
                label="First Name"
                onChange={handleChange}
                required
                value={data?.first_name || ""}
                fullWidth
                size="small"
                placeholder="Enter first name"
              />
            </Box>
            
            <Box sx={{ flex: '1 1 calc(50% - 8px)', minWidth: '150px' }}>
              <CustomInput
                name="last_name"
                label="Last Name"
                onChange={handleChange}
                value={data?.last_name || ""}
                fullWidth
                size="small"
                placeholder="Enter last name"
              />
            </Box>
          </Box>
          
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            <Box sx={{ flex: '1 1 calc(50% - 8px)', minWidth: '150px' }}>
              <CustomSelect
                name="gender"
                options={genderOptionsFormatted}
                onChange={handleChange}
                label="Gender"
                value={data?.gender || ""}
                placeholder="Select Gender"
                fullWidth
                size="small"
              />
            </Box>
            
            <Box sx={{ flex: '1 1 calc(50%)', minWidth: '150px' }}>
              <CustomDate
                name="birthdate"
                label="Birthdate"
                onChange={handleChange}
                value={data?.birthdate || ""}
                fullWidth
                size="small"
              />
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CandidateProfileForm;